module.exports = __webpack_public_path__ + "img/img_renzheng_340.04d979fe.png";